import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { withLDProvider } from 'launchdarkly-react-client-sdk';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const AppWithLaunchDarkly = () => {

  const LDProviderWrappedApp = withLDProvider({
    clientSideID: String(process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_ID),
    user: {
      key: 'anonymous-user'
    },
  })(App);
  return <LDProviderWrappedApp />;
};

root.render(
  <React.StrictMode>
    <AppWithLaunchDarkly />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
